import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';

import { QuickStatsMessage } from '../../../../types/QuickStatsMessage';
import { queries } from '../../../common/api/queryKeys/queries';

type UseStatsQueryResult = UseQueryResult<QuickStatsMessage> & {
    prefetch: () => Promise<void>;
};

const PREFETCH_TIMEOUT_MS = 3000;

const withTimeout = <T>(promise: Promise<T>, timeoutMs: number): Promise<T | void> => {
    return Promise.race([
        promise,
        new Promise<void>((resolve) => {
            setTimeout(() => resolve(), timeoutMs);
        }),
    ]);
};

export const useStats = (enabled = true): UseStatsQueryResult => {
    const queryClient = useQueryClient();

    const prefetch = () => {
        const prefetchPromise = queryClient.prefetchQuery({
            ...queries.reports.quickStats,
        });

        return withTimeout(prefetchPromise, PREFETCH_TIMEOUT_MS);
    };

    const query = useQuery({
        ...queries.reports.quickStats,
        enabled,
    });

    return {
        ...query,
        prefetch,
    };
};
